import { useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "../lib/api";

export default function EmployeePasswordDialog({ employee, onClose, onSaved }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (password.length < 6) {
      toast.error("كلمة المرور 6 أحرف على الأقل");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("تأكيد كلمة المرور غير مطابق");
      return;
    }
    setBusy(true);
    try {
      await api.patch(`/employees/${employee.id}`, { password });
      toast.success("تم تغيير كلمة مرور الموظف");
      onSaved();
    } catch (error) {
      toast.error(formatErr(error));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-40 grid place-items-end bg-black/50 p-4 sm:place-items-center"
      onClick={onClose}
      data-testid="employee-password-dialog"
    >
      <div
        onClick={(event) => event.stopPropagation()}
        className="w-full max-w-md rounded-3xl bg-white p-5 rise-in"
      >
        <div className="mb-3 flex items-center justify-between">
          <div>
            <div className="text-lg font-extrabold">تغيير كلمة المرور</div>
            <div className="text-xs text-gray-500" data-testid="employee-password-target">
              {employee.name}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            className="grid h-9 w-9 place-items-center rounded-xl bg-gray-100 text-gray-600"
            aria-label="إغلاق"
            data-testid="employee-password-close"
          >
            <X size={18}/>
          </button>
        </div>
        <PasswordField
          label="كلمة المرور الجديدة"
          value={password}
          onChange={setPassword}
          testid="employee-password-new"
          autoFocus
        />
        <PasswordField
          label="تأكيد كلمة المرور"
          value={confirmPassword}
          onChange={setConfirmPassword}
          testid="employee-password-confirm"
        />
        <button
          type="button"
          onClick={save}
          disabled={busy}
          className="mt-4 w-full pill brand-grad py-3 font-bold text-white disabled:opacity-60"
          data-testid="employee-password-save"
        >
          {busy ? "جاري الحفظ…" : "حفظ كلمة المرور"}
        </button>
      </div>
    </div>
  );
}

function PasswordField({ label, value, onChange, testid, autoFocus = false }) {
  return (
    <label className="mt-3 block">
      <span className="text-xs font-bold text-gray-600">{label}</span>
      <input
        type="password"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        minLength={6}
        autoFocus={autoFocus}
        className={
          "mt-1 h-12 w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 "
          + "outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-100"
        }
        data-testid={testid}
      />
    </label>
  );
}